import React from 'react';

const Situation = (props) => {
    let {
        currentSituation,
        labels,
        showSituationHearing,
        getNextQuestion,
        verifyIfHearing,
        verifyIfReading,
        disabledHearingButton,
        getAudioForSituation
    } = props;

    return(
        <div className="m-portlet m-portlet--primary m-portlet--head-solid-bg mb-0">
            <div className="m-portlet__head">
                <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                        <h3 className="m-portlet__head-text">{ currentSituation.Titulo }</h3>
                    </div>
                </div>
            </div>
            <div className="m-portlet__body m-form__group form-group m-radio-list mb-0">
                { verifyIfReading(currentSituation.TipoSituacion) && currentSituation.Situacion }
            </div>

            <div className="m-portlet__foot">
                <button className="btn m-btn--square btn-primary mr-5" onClick={getNextQuestion}>
                    { labels.Siguiente }
                </button>
                { verifyIfHearing(currentSituation.TipoSituacion) &&
                    <button className="btn m-btn--square btn-info"
                            disabled={disabledHearingButton}
                            onClick={showSituationHearing}>
                        { labels.Escuchar }
                    </button>
                }
                { verifyIfHearing(currentSituation.TipoSituacion) &&
                    <audio className='m--hide' autobuffer="autobuffer" controls="controls" id="audio_player"
                           src={`data:audio/mp3;base64,${getAudioForSituation()}`}>
                    </audio>
                }
            </div>
        </div>
    );
};

export default Situation;
